// extracted by mini-css-extract-plugin
module.exports = {"root":"Toolbox__root--3K-aW"};